import { i as o, r, l as e, n as i, t as m, D as t } from "./FormErrorMessage-C4ydi9Qu-D0_4CrD9.js";
import { css as a } from "@emotion/css";
const s = {
  wrapper: a({
    display: "inline-flex",
    fontWeight: o.semiBold,
    fontSize: r.small,
    fontFamily: e.body,
    lineHeight: 1.2,
    color: i.jumbo,
    marginTop: m.extraSmall
  })
}, c = ({ text: l }) => /* @__PURE__ */ t.jsx("small", { className: s.wrapper, children: l });
export {
  c
};
